export default __webpack_public_path__ + "static/media/KOD0016-min.f29c4d58.webp";